module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_7016.16af9dba.png";